import React from 'react';
import classNames from 'classnames';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import type { StepHeaderShimmerClasses } from './types';

const getSearchCampaignWizardStepsShimmerStyles = () => ({
  step: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    gap: '12px',
  },
  header: {
    marginBottom: '8px',
  },
  section: {
    width: '100%',
  },
  row: {
    display: 'flex',
    gap: '12px',
    width: '100%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
  },
});

const renderStepHeaderShimmer = (classes: StepHeaderShimmerClasses) => (
  <>
    <div className={classes.header}>
      <Skeleton appearance="translucent"><SkeletonItem style={{ height: '30px', width: '280px' }} /></Skeleton>
    </div>
    <Skeleton appearance="translucent"><SkeletonItem style={{ height: '16px', width: '100%' }} /></Skeleton>
    <Skeleton appearance="translucent"><SkeletonItem style={{ height: '16px', width: '70%' }} /></Skeleton>
  </>
);

// @aiContributed-MAPFuse-2026-02-28
export const CampaignSettingsStepShimmer = () => {
  const classes = useDefaultStyles(getSearchCampaignWizardStepsShimmerStyles);

  return (
    <div className={classNames('campaign-settings-step-shimmer', classes.step)}>
      {renderStepHeaderShimmer(classes)}
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '96px', width: '100%' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '128px', width: '100%' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '220px', width: '100%' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '128px', width: '100%' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '160px', width: '100%' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '56px', width: '100%' }} /></Skeleton>
      </div>
    </div>
  );
};

export const KeywordsStepShimmer = () => {
  const classes = useDefaultStyles(getSearchCampaignWizardStepsShimmerStyles);

  return (
    <div className={classNames('keywords-step-shimmer', classes.step)}>
      {renderStepHeaderShimmer(classes)}
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '170px', width: '100%' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '220px', width: '100%' }} /></Skeleton>
      </div>
    </div>
  );
};

export const AddTextStepShimmer = () => {
  const classes = useDefaultStyles(getSearchCampaignWizardStepsShimmerStyles);

  return (
    <div className={classNames('add-text-step-shimmer', classes.step)}>
      {renderStepHeaderShimmer(classes)}
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '44px', width: '220px' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '420px', width: '100%' }} /></Skeleton>
      </div>
    </div>
  );
};

export const ExtensionsStepShimmer = () => {
  const classes = useDefaultStyles(getSearchCampaignWizardStepsShimmerStyles);

  return (
    <div className={classNames('extensions-step-shimmer', classes.step)}>
      {renderStepHeaderShimmer(classes)}
      <div className={classes.row}>
        <div className={classes.column}>
          <Skeleton appearance="translucent"><SkeletonItem style={{ height: '190px', width: '100%' }} /></Skeleton>
          <Skeleton appearance="translucent"><SkeletonItem style={{ height: '190px', width: '100%' }} /></Skeleton>
        </div>
      </div>
    </div>
  );
};

export const BudgetAndBidsStepShimmer = () => {
  const classes = useDefaultStyles(getSearchCampaignWizardStepsShimmerStyles);

  return (
    <div className={classNames('budget-and-bids-step-shimmer', classes.step)}>
      {renderStepHeaderShimmer(classes)}
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '190px', width: '100%' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '230px', width: '100%' }} /></Skeleton>
      </div>
      <div className={classes.section}>
        <Skeleton appearance="translucent"><SkeletonItem style={{ height: '150px', width: '100%' }} /></Skeleton>
      </div>
    </div>
  );
};
